import { createContext, useContext } from "react";

export const ModalActions = createContext();

export const useModalActions = () => useContext(ModalActions);

export const Online = createContext();

export const useOnline = () => useContext(Online);
